// extracted by mini-css-extract-plugin
module.exports = {"page_create":"Create_page_create__32egV","navi":"Create_navi__2oA9a","fadeIn":"Create_fadeIn__3YqFO","scaleXin":"Create_scaleXin___LT7L"};